// utils/stringPrototype.ts
declare global {
  interface String {
    firstTwoWords(): string;
  }
}

String.prototype.firstTwoWords = function (): string {
  if (!this) return '';
  const words = this.trim().split(/\s+/); // split by spaces
  return words.length > 2 ? words.slice(0, 2).join(' ') : this.toString();
};

declare global {
  interface String {
    enabled(): boolean;
  }
}

String.prototype.enabled = function (): boolean {
  if (this == null) return false;

  const numericFlag = Number(this.toString());
  return Boolean(numericFlag);
};

export {}; // Required for module scope
